import z from 'zod';
import { auditableSchema, entitySchema, PaginatedResponseBuilder, paginationParamsSchema } from '../shared.types';

////////
// Types used specifically for Community APIs
////////

export const communitySearchSchema = z.object({
    ...paginationParamsSchema.shape,
    subscriptionId: z.number().int().optional(),
    isActive: z.boolean().optional().nullable(),
    name: z.string().nullable().optional(),
});

export const communitySchema = z.object({
    ...entitySchema.shape,
    ...auditableSchema.shape,
    subscriptionId: z.number().int(),
    name: z.string().min(1, 'Name cannot be empty'),
    isActive: z.boolean(),
});

// Create a specific schema for paginated communities
export const paginatedCommunityResponseSchema = PaginatedResponseBuilder(communitySchema);

// Infer the types from the specific schemas
export type CommunityType = z.infer<typeof communitySchema>;
export type CommunitiesSearch = z.infer<typeof communitySearchSchema>;
export type PaginatedCommunityResponse = z.infer<typeof paginatedCommunityResponseSchema>;
